<template>
  <form @submit.prevent id="login">
    <section class="overlay" v-if="errored">
      <p class="overlay-text">申し訳ありませんが、<br />現時点ではこの情報を取得できません。<br />しばらくしてからもう一度お試しください</p>
    </section>

    <section v-else>
      <div class="overlay" v-if="loading">
        <p class="overlay-text loading-text">Loading...</p>
        <div class="loading-spacer">
          <vue-loading type="spiningDubbles" color="#FFF" :size="{ width: '100px', height: '100px' }"></vue-loading>
        </div>
      </div>
      <div class="margin-bottom-12">
        <label class="error-text">{{ mailError }}</label>
        <InputMail @handle-change-mail="changeMail" />
      </div>
      <label class="error-text">{{ passwordError }}</label>
      <InputPassword @handle-change-password="changePassword" />
      <div class="login">
        <img class="login-img" src="@/assets/top/アセット 2@2x.png" @click="clickLogin" />
      </div>
    </section>
  </form>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const AccountRepository = RepositoryFactory.get("account");
const UserRepository = RepositoryFactory.get("user");
import InputMail from "@/molecules/InputMail.vue";
import InputPassword from "@/molecules/InputPassword.vue";
import { checkPassword } from "@/module/validation.js";
import { checkMail } from "@/module/validation.js";
import { VueLoading } from "vue-loading-template";
export default {
  components: {
    InputMail: InputMail,
    InputPassword: InputPassword,
    VueLoading,
  },
  data() {
    return {
      mailValue: "",
      passwordValue: "",
      mailError: "",
      passwordError: "",
      checkFlg: Boolean,
      users: [],
      account: Object,
      loading: false,
      errored: false,
      refreshToken: "",
    };
  },
  methods: {
    clickLogin() {
      this.checkFlg = true;
      (this.mailError = ""), (this.passwordError = "");
      if (!checkMail(this.mailValue)) {
        this.mailError = "・メールアドレスの形式が正しくありません";
        this.checkFlg = false;
      }
      if (!checkPassword(this.passwordValue)) {
        this.passwordError = "・パスワードを8文字以上入力してください";
        this.checkFlg = false;
      }
      if (this.mailValue && this.passwordValue && this.checkFlg) {
        this.loading = true;
        this.login();
      }
    },
    async login() {
      const UserEndpoint = "login";
      const body = {
        username: this.mailValue,
        password: this.passwordValue,
      };
      await UserRepository.post(UserEndpoint, body)
        .then((response) => (this.users = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          this.$store.commit("FETCH_ADD_USERS", this.users);
        });

      let headers = {
        Authorization: "Bearer " + this.users.access_token,
        "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        access_token_expires_in: this.users.access_token_expires_in,
        refresh_token: this.users.refresh_token,
      };
      this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
      this.accountPartApi(headers);
    },

    async accountPartApi(headers) {
      const accountEndpoint = "part?gender=" + this.users.gender;
      await AccountRepository.get(accountEndpoint, headers)
        .then((response) => {
          if (!Object.keys(response.data).length) {
            this.$router.push("/accountCreate");
          } else {
            this.$router.push("/home");
          }
        }).catch((error) => {
          console.log(error);
          this.errored = true;
        }).finally(() => (this.loading = false));
    },
    changeMail(val) {
      this.mailValue = val;
    },
    changePassword(val) {
      this.passwordValue = val;
    },
  },
};
</script>

<style scoped>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 10;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.overlay p {
  color: white;
  font-size: 1.2rem;
}
p.overlay-text {
  color: white;
  font-size: 1.2rem;
}
p.loading-text {
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/organisms/LoginForm.vue